import { createAction } from 'redux-actions';

export const GetAdvertisementRequested = createAction('GET_ADVERTISEMENT_REQUESTED');
export const GetAdvertisementReceived = createAction('GET_ADVERTISEMENT_RECEIVED');
export const GetAdvertisementReceiveFailure = createAction('GET_ADVERTISEMENT_RECEIVE_FAILURE');
export const ClearGetAdvertisement = createAction('CLEAR_GET_ADVERTISEMENT');

export const CreateAdvertisementRequested = createAction('CREATE_ADVERTISEMENT_REQUESTED');
export const CreateAdvertisementReceived = createAction('CREATE_ADVERTISEMENT_RECEIVED');
export const CreateAdvertisementReceiveFailure = createAction('CREATE_ADVERTISEMENT_RECEIVE_FAILURE');
export const ClearCreateAdvertisement = createAction('CLEAR_CREATE_ADVERTISEMENT');

export const UpdateAdvertisementRequested = createAction('UPDATE_ADVERTISEMENT_REQUESTED');
export const UpdateAdvertisementReceived = createAction('UPDATE_ADVERTISEMENT_RECEIVED');
export const UpdateAdvertisementReceiveFailure = createAction('UPDATE_ADVERTISEMENT_RECEIVE_FAILURE');
export const ClearUpdateAdvertisement = createAction('CLEAR_UPDATE_ADVERTISEMENT');

export const DeleteAdvertisementRequested = createAction('DELETE_ADVERTISEMENT_REQUESTED');
export const DeleteAdvertisementReceived = createAction('DELETE_ADVERTISEMENT_RECEIVED');
export const DeleteAdvertisementReceiveFailure = createAction('DELETE_ADVERTISEMENT_RECEIVE_FAILURE');
export const ClearDeleteAdvertisement = createAction('CLEAR_DELETE_ADVERTISEMENT');
